<template>
  <div class="error-page" :class="{ pcStyle: isPc, mobileStyle: isMobile }">
    <div class="error-tips">
      <div class="header">
        <div class="icon-box">
          <img class="icon" src="@/assets/images/failed.png" alt="" />
        </div>
        <!-- <div class="pay-result">{{ i18n.completeInfoModule.errorPageTitle }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import NavBar from '@/components/NavBar.vue';
  import ResizeMixin from '@/mixin/ResizeHandler';
  export default {
    components: {
      NavBar,
    },
    mixins: [ResizeMixin],
    created() {
    },
  };
</script>
<style lang="less" scoped>
.mobileStyle {
  &.error-page {
    width: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #eee;
    box-sizing: border-box;
    overflow: auto;
    padding-top: 44px;
    padding-bottom: 50px;
    .header {
      margin-top: 100px;
      padding: 0 10%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        width: 50px;
        height: 50px;
      }
      .pay-result {
        text-align: left;
        line-height: 1.5;
        font-size: 18px;
        font-weight: 400;
        color: #000;
        margin-top: 20px;
      }
    }
  }
}

.pcStyle {
  &.error-page {
    margin: 0 auto;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #eee;
    box-sizing: border-box;
    overflow: auto;
    padding-top: 44px;
    padding-bottom: 50px;
    .header {
      margin-top: 100px;
      padding: 0 10%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        width: 50px;
        height: 50px;
      }
      .pay-result {
        text-align: left;
        line-height: 1.5;
        font-size: 18px;
        font-weight: 400;
        color: #000;
        margin-top: 20px;
      }
    }
  }
}
</style>